module.exports = __webpack_public_path__ + "static/media/logoCompany-old.2ec9319f.svg";